import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  RequestPasswordResetRequest,
  ResetPasswordRequest,
  PasswordResetResponse,
} from './auth.models';

/**
 * Handles password reset flows (request code + reset with code).
 */
@Injectable({
  providedIn: 'root',
})
export class AuthPasswordService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  requestPasswordReset(request: RequestPasswordResetRequest): Observable<PasswordResetResponse> {
    return this.http.post<PasswordResetResponse>(
      `${this.apiUrl}/auth/request-password-reset`,
      request,
    );
  }

  resetPassword(request: ResetPasswordRequest): Observable<PasswordResetResponse> {
    return this.http.post<PasswordResetResponse>(
      `${this.apiUrl}/auth/reset-password`,
      request,
    );
  }
}
